import React from "react";
import { Layout } from "antd";

const { Content } = Layout;
export const TransferContent = (props) => (
  <div className="col-md-12 ">{props.children}</div>
);
